export default __webpack_public_path__ + "static/media/AngelAvatar.c42e6a1d.svg";